import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestResponse } from '../model/responses/RestResponse';
import { ExternalApplicationCreationRequest } from '../model/requests/external-application-creation-request';
import { delay } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';


@Injectable({
  providedIn: 'root'
})
export class PortalDAO {

    private readonly entityURL: string;

    constructor(private httpClient: HttpClient) {
        this.entityURL = '/rest/applications';
    }

    public getPortalLinks() {
        const url = `${this.entityURL}`;
        return this.httpClient.get<any[]>(url);
    }

    public getExternalApplication(externalApplicationUuid: string) {
        const url = `${this.entityURL}/external/${externalApplicationUuid}`;
        return this.httpClient.get(url, )
            .toPromise()
            .then((response: RestResponse) => response)
            .catch();
    }

    public createExternalApplication(formData: FormData): Promise<void> {
        const url = `${this.entityURL}/external/new`;
        return this.httpClient.post(url, formData)
                    .toPromise()
                    .then(() => {})
                    .catch();
    }

    public editExternalApplication(formData: FormData, externalApplicationUuid: string) : Promise<void> {
        const url = `${this.entityURL}/external/${externalApplicationUuid}/edit`;
        return this.httpClient.put(url, formData)
                    .toPromise()
                    .then(() => {})
                    .catch();
    }

    public deleteExternalApplication(externalApplicationUuid: string): Promise<void> {
        const url = `${this.entityURL}/external/${externalApplicationUuid}/delete`;
        return this.httpClient.delete(url, )
                    .toPromise()
                    .then(() => {})
                    .catch();
    }
}
